import React from 'react'
import { JsonForms } from '@jsonforms/react'
import { materialCells } from '@jsonforms/material-renderers'
import FormComponent from 'designer/component/component/FormComponent'

const isSameJsonFormsData = (currentData, nextData) => {
  if (currentData === nextData) return true
  try {
    return JSON.stringify(currentData ?? {}) === JSON.stringify(nextData ?? {})
  } catch (error) {
    return false
  }
}

const Container = (props) => {
  let { data, schema, uischema, path, handleChange, config, renderers } = props
  const formCode = uischema?.loadForm?.formCode

  if (formCode) {
    return (
      <FormComponent
        {...props}
        sourceType="form"
        tabDesignCode={formCode}
        config={{ ...config, isFormComponent: true, formComponent: uischema }}
      />
    )
  }

  return (
    <JsonForms
      schema={schema}
      uischema={{ type: 'VerticalLayout', elements: uischema.elements }}
      data={data}
      renderers={renderers}
      cells={materialCells}
      onChange={({ data, errors }) => {
        if (isSameJsonFormsData(props.data, data)) return
        handleChange(path, data)
      }}
      config={config}
    />
  )
}
export default Container
